import { Link } from 'react-router-dom';
import { OVERVIEW_PANEL as T } from '@locales/id/overview';
import { Icon } from './Icon';

/** The one "Lihat semua" under a bounded feed: to the page that owns the list, with the matching filter. */
export function PanelMore({ to, label }: { to: string; label: string }) {
  return (
    <div className="side-more">
      <Link to={to} aria-label={label} className="side-more-link">
        {T.seeAll}
        <Icon name="next" size={14} />
      </Link>
    </div>
  );
}
